export const BYTES_IN_MB = 1024000;
export const MAX_FILE_SIZE = BYTES_IN_MB * 30;
export const MAX_FILE_SIZE_HUMAN_READABLE = '30MB';
